module.exports = __webpack_public_path__ + "img/1524209279.c9e82f65.jpg";